import {XauditModel} from '../xaudit.model';
import {ContactDataModel} from '../person/contact-data.model';
import {DoctorLicenseDataModel} from './doctor-license-data.model';
import {DoctorLocationDataModel, DoctorRefLocationDataModel} from './doctor-location-data.model';
import {DoctorSpecialtyDataModel} from './doctor-specialty-data.model';
import {EnumValidValueItemModel} from '../enum/enum-valid-value-item.model';
import {DoctorArLocationDataModel} from './doctor-ar-location-data.model';

export class DoctorDataModel extends XauditModel {
  ContactId: string;
  DEA: string;
  NPI: string;
  DoctorId: string;
  LOCID: number;
  NoteGroupId: string;
  ReportName: string;
  TaxID: string;
  Title: string;
  UserId: string;
  UserName: string;
  dataContact: ContactDataModel;
  dataDoctorContacts: ContactDataModel[];
  // TODO: spelling
  dataDoctorLicences: DoctorLicenseDataModel[];
  dataDoctorLocations: DoctorLocationDataModel[];
  dataDoctorRefLocations: DoctorRefLocationDataModel[];
  // TODO: spelling
  dataDoctorSpecialties: DoctorSpecialtyDataModel[];
  dataDoctorARLocations: DoctorArLocationDataModel[];
  enumDoctorClassificationID: string;
  enumDoctorTypeID: string;
  enumValidValueItem: EnumValidValueItemModel;
  PortraitDocumentID: string;
  SignatureDocumentID: string;
  isActiveDoctor: boolean;


}
